var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("modal", {
    ref: "media-gallery",
    attrs: {
      name: "media-gallery",
      "extra-class": "full-screen-modal media-gallery-modal",
      "safe-close": true
    },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function(props) {
          return [
            _c("media-gallery", {
              attrs: {
                buttons: props.data.buttons,
                "first-active": props.data.first_active,
                "active-image": props.data.active_image,
                media: props.data.estate.media
              }
            })
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }